<template>
  <svg
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M11.1033 4.81699C11.4701 4.07374 12.5299 4.07374 12.8967 4.81699L14.7344 8.54005L18.8431 9.13703C19.6633 9.25622 19.9908 10.2642 19.3973 10.8427L16.4248 13.7409L17.1264 17.8339C17.2665 18.6508 16.409 19.2738 15.6754 18.8881L12 16.9553L8.32456 18.8881C7.59104 19.2738 6.73348 18.6508 6.87358 17.8339L7.57516 13.7409L4.60269 10.8427C4.00921 10.2642 4.33666 9.25622 5.15693 9.13703L9.2656 8.54005L11.1033 4.81699Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
</template>